/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GroupMemberDay = zod.object({
  date: zod.iso.date(),
  read: zod
    .union([zod.literal('self'), zod.literal('leader'), zod.literal(null)])
    .nullable()
    .describe('Who finished it: the member, a leader marking it, or nobody yet'),
  write: zod
    .union([zod.literal('self'), zod.literal('leader'), zod.literal(null)])
    .nullable()
    .describe('Who finished it: the member, a leader marking it, or nobody yet'),
  math: zod
    .union([zod.literal('self'), zod.literal('leader'), zod.literal(null)])
    .nullable()
    .describe('Who finished it: the member, a leader marking it, or nobody yet'),
});

export type GroupMemberDay = zod.input<typeof GroupMemberDay>;
export type GroupMemberDayOutput = zod.output<typeof GroupMemberDay>;
